"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbilityMetas = void 0;
const enums_1 = require("../core/enums");
exports.AbilityMetas = {
    // Time Keeper
    Continuance: {
        name: "Continuance",
        flavorText: "Passive that withers everyone around.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Diverge: {
        name: "Diverge",
        flavorText: "Instantly Withers everyone around. Changes to raw damage as the battle progresses.",
        attackType: "magical",
        power: 60,
        damageTypes: [enums_1.DamageType.Chaos]
    },
    Decompose: {
        name: "Decompose",
        flavorText: "Accelerates the target's withering, consuming it and dealing damage immediately.",
        attackType: "magical",
        power: 0,
        damageTypes: [enums_1.DamageType.Chaos]
    },
    Reconstruct: {
        name: "Reconstruct",
        flavorText: "Reverses the target's withering, consuming it and applying regeneration.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    Replay: {
        name: "Replay",
        flavorText: "Replays damage to the last 3 + <turn> actors that were attacked.",
        attackType: "magical",
        power: 20,
        damageTypes: [enums_1.DamageType.Chaos]
    },
    Evolve: {
        name: "Evolve",
        flavorText: "Consumes the target's withering to grant them random buffs.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Calculus: {
        name: "Calculus",
        flavorText: "Consumes the target's withering to debilitate them.",
        attackType: "debuff",
        power: 0,
        damageTypes: []
    },
    Stasis: {
        name: "Stasis",
        flavorText: "Places the target into stasis, healing them for 50% damage, making them immune to all damage and preventing them from taking turns.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    Haste: {
        name: "Haste",
        flavorText: "Consumes the target's withering causing them to take their turn sooner, but slowing their future turns down.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Impede: {
        name: "Impede",
        flavorText: "Consume's the target's withering causing them to take their turn later, but hastening their future turns.",
        attackType: "debuff",
        power: 0,
        damageTypes: []
    },
    Shape: {
        name: "Shape",
        flavorText: "Causes all attacks to wither their target.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    NaN: {
        name: "NaN",
        flavorText: "Consumes the target's withering granting them extra actions on their next turn. Requires 50 withering on the target.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    TauntingShout: {
        name: "Taunting Shout",
        flavorText: "Forces all enemies to target the caster.",
        attackType: "debuff",
        power: 0,
        damageTypes: [],
    },
    Corrode: {
        name: "Corrode",
        flavorText: "Viscous acid is applied to two enemies.",
        attackType: "magical",
        power: 50,
        damageTypes: []
    },
    // Warrior
    Chop: {
        name: "Chop",
        flavorText: "Physical attacks that deals Physical damage. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Cyclone: {
        name: "Cyclone",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 50. Makes the targets vulnerable.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Eviscerate: {
        name: "Eviscerate",
        flavorText: "Physical attack that deals Physical damage. Base power 80. Causes the target to bleed.",
        attackType: "physical",
        power: 80,
        damageTypes: [enums_1.DamageType.Physical]
    },
    AxeThrow: {
        name: "Axe Throw",
        flavorText: "Physical attack that deals Physical damage. Base power 55. Makes the target vulnerable.",
        attackType: "physical",
        power: 55,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Whirlwind: {
        name: "Whirlwind",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 70. Increases caster's damage. Makes the targets vulnerable.",
        attackType: "physical",
        power: 70,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Painkiller: {
        name: "Painkiller",
        flavorText: "Heals the caster for 25% of their max health. Caster regenerates health each turn.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    Overload: {
        name: "Overload",
        flavorText: "Self buff that increases the caster's haste.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Bodyguard: {
        name: "Bodyguard",
        flavorText: "Buff that blocks the next attack that would hit the target.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    RapidStrikes: {
        name: "Rapid Strikes",
        flavorText: "Physical attack that deals Physical damage 2 to 5 times to an enemy. Base power 30. Each hit makes the target vulnerable.",
        attackType: "physical",
        power: 30,
        damageTypes: [enums_1.DamageType.Physical]
    },
    NjordsWarcry: {
        name: "Njord's Warcry",
        flavorText: "Group buff that increases the power and critical strike chance of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Physical]
    },
    BamsBouncingThunderclap: {
        name: "Bam's Bouncing Thunderclap",
        flavorText: "Physical attack that deals Sonic and Nature damage. Base power 180. Deals more damage to fewer targets.",
        attackType: "physical",
        power: 180,
        damageTypes: [enums_1.DamageType.Sonic, enums_1.DamageType.Nature]
    },
    // Vampire
    Slice: {
        name: "Slice",
        flavorText: "Physical attack that deals Physical damage. Base power 45. Causes the target to bleed.",
        attackType: "physical",
        power: 45,
        damageTypes: [enums_1.DamageType.Physical]
    },
    BloodPact: {
        name: "Blood Pact",
        flavorText: "Physical attack that deals Physical damage. Base power 60. Heals the caster. Causes the target to bleed.",
        attackType: "physical",
        power: 60,
        damageTypes: [enums_1.DamageType.Physical]
    },
    SigilOfBlood: {
        name: "Sigil of Blood",
        flavorText: "Passive: Self buff that causes attacks to heal allies. Active: Physical attack that deals Death damage. Base power 100. Stuns target.",
        attackType: "buff",
        power: 100,
        damageTypes: [enums_1.DamageType.Death]
    },
    EmiliasKissOfSorrow: {
        name: "Emilia's Kiss of Sorrow",
        flavorText: "Physical attack that deals Physical damage. Base power 55. Causes the target to bleed. Burns the target.",
        attackType: "physical",
        power: 55,
        damageTypes: [enums_1.DamageType.Physical]
    },
    MidnightsGaze: {
        name: "Midnight's Gaze",
        flavorText: "Physical attack that deals Physical damage. Base power 45. Reduces target's chance to hit.",
        attackType: "physical",
        power: 45,
        damageTypes: [enums_1.DamageType.Death]
    },
    SigilOfDamnation: {
        name: "Sigil Of Damnation",
        flavorText: "Passive: Self buff that increases caster's haste. Active: Debuff that increases all damage taken by the enemy. Further increases death damage taken by the target.",
        attackType: "debuff",
        power: 0,
        damageTypes: [enums_1.DamageType.Death]
    },
    FrejasEpidemic: {
        name: "Freja's Epidemic",
        flavorText: "Physical attack that deals Death damage to all enemies. Base power 50. Diseases targets.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Death]
    },
    VisionOfKatajen: {
        name: "Vision of Katajen",
        flavorText: "Physical attack that deals Physical damage 2 to 5 times to an enemy. Base power 30. Heals allies. Causes the target to bleed.",
        attackType: "physical",
        power: 30,
        damageTypes: [enums_1.DamageType.Physical]
    },
    HammeringOfDmina: {
        name: "Hammering of Dmina",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 70. Causes targets to bleed.",
        attackType: "physical",
        power: 70,
        damageTypes: [enums_1.DamageType.Physical]
    },
    SigilOfTheDamken: {
        name: "Sigil of the Damken",
        flavorText: "Passive: Self buff that increase the Vampire's primary attributes. Active: Physical attack that deals Death damage. Base power 100. Damages enemies that attack the caster.",
        attackType: "physical",
        power: 100,
        damageTypes: [enums_1.DamageType.Death]
    },
    AugurysFinalOmen: {
        name: "Augury's Final Omen",
        flavorText: "Physical attack that deals Death and Physical damage. Base power 180. Damage is increased if target is bleeding. Causes the target to bleed.",
        attackType: "physical",
        power: 180,
        damageTypes: [enums_1.DamageType.Death, enums_1.DamageType.Physical]
    },
    // Valkyrie
    FlamesOfWar: {
        name: "Flames of War",
        flavorText: "Passive buff that grants a chance to burn attackers.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Arc: {
        name: "Arc",
        flavorText: "Physical attack that deals Nature damage. Base power 45. Burns the target.",
        attackType: "physical",
        power: 45,
        damageTypes: [enums_1.DamageType.Nature]
    },
    WingBuffett: {
        name: "Wing Buffet",
        flavorText: "Magical attack that deals Physical damage. Base power 70. Stuns the target.",
        attackType: "magical",
        power: 70,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Shatter: {
        name: "Shatter",
        flavorText: "Physical attack that deals Physical damage. Base power 55. Makes the target vulnerable.",
        attackType: "physical",
        power: 55,
        damageTypes: [enums_1.DamageType.Physical]
    },
    TemporalShift: {
        name: "Temporal Shift",
        flavorText: "Self buff that increases the caster's damage resistance and haste.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ShieldOfKatalina: {
        name: "Shield of Katalina",
        flavorText: "Self buff that increases the caster's critical strike chance, burn damage and haste.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    FlamesOfTobias: {
        name: "Flames of Tobias",
        flavorText: "Magical attack that deals Fire damage. Base power 70. Burns the target. Increases fire damage taken by the target.",
        attackType: "magical",
        power: 70,
        damageTypes: [enums_1.DamageType.Fire]
    },
    ObidiahsBurningIncantation: {
        name: "Obidiah's Burning Incantation",
        flavorText: "Magical attack that deals Fire damage . Base power 100. Burns the target. Burns applied to the target deal increased damage.",
        attackType: "magical",
        power: 100,
        damageTypes: [enums_1.DamageType.Fire]
    },
    ReflectionOfTessalyn: {
        name: "Reflection Of Tessalyn",
        flavorText: "Self buff that reflects damage back at enemies. Caster regenerates health each turn.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    BurningOfCyrus: {
        name: "Burning Of Cyrus",
        flavorText: "Magical attack that deals fire damage. Base power 100. Burns the target.",
        attackType: "magical",
        power: 100,
        damageTypes: [enums_1.DamageType.Fire]
    },
    DarkCarnival: {
        name: "Dark Carnival",
        flavorText: "Magical attack that deals Fire damage to all enemies. Base power 180. Summons up to two Arch Angels to aid the valkyrie.",
        attackType: "magical",
        power: 180,
        damageTypes: [enums_1.DamageType.Fire]
    },
    // High Priestess
    Blast: {
        name: "Blast",
        flavorText: "Magical attack that deals Holy damage. Base power 50.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Holy]
    },
    Heal: {
        name: "Heal",
        flavorText: "Heals an ally. Target regenerates health each turn.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    Regeneration: {
        name: "Regeneration",
        flavorText: "Buff that causes an ally to regenerate health each turn.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Resurrection: {
        name: "Resurrection",
        flavorText: "Brings an ally back to life.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    AeridynesSpring: {
        name: "Aeridyne's Spring",
        flavorText: "Group buff that causes all allies to regenerate health each turn.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    SorisHug: {
        name: "Sori's Hug",
        flavorText: "Heals the caster's allies.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    BlessingOfAlaresa: {
        name: "Blessing of Alaresa",
        flavorText: "Group buff that increases the primary attributes of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    TessasAscension: {
        name: "Tessa's Ascension",
        flavorText: "Buff that increases an ally's Haste and Focus.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    WhispersOfTheAncientOne: {
        name: "Whispers of the Ancient One",
        flavorText: "Heals an ally. Removes all harmful effects.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    ShieldOfSylvie: {
        name: "Shield of Sylvie",
        flavorText: "Group buff that increases the Health and Toughness of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    NorisSacrifice: {
        name: "Nori's Sacrifice",
        flavorText: "Completely heals all allies and removes all negative effects.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    Sanctuary: {
        name: "Sanctuary",
        flavorText: "Heals an ally. Grants the target a shield that absorbs damage.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    DivineResolution: {
        name: "Divine Resolution",
        flavorText: "Passive Buff that increases the bearer's healing and heals all allies at start of turn.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Augur
    Zap: {
        name: "Zap",
        flavorText: "Magical attack that deals Death damage. Base power 50.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Death]
    },
    Omen: {
        name: "Omen",
        flavorText: "Magical attack that deals Death damage. Base power 45. Curses the target.",
        attackType: "magical",
        power: 45,
        damageTypes: [enums_1.DamageType.Death]
    },
    SignaExCoelo: {
        name: "Signa Ex Coelo",
        flavorText: "Magical attack that deals Death damage. Base power 80.",
        attackType: "magical",
        power: 80,
        damageTypes: [enums_1.DamageType.Death]
    },
    HexOfXiia: {
        name: "Hex Of Xiia",
        flavorText: "Magical attack that deals Death damage to all enemies. Base power 70. Curses the targets. Reduces targets' chance to hit.",
        attackType: "magical",
        power: 70,
        damageTypes: [enums_1.DamageType.Death]
    },
    NorthsInfinitum: {
        name: "North's Infinitum",
        flavorText: "Group buff that Increases the caster's maximum health and the primary attributes of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    RavensCall: {
        name: "Raven's Call",
        flavorText: "Bring's an ally back to life.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    SignaExDiris: {
        name: "Signa Ex Diris",
        flavorText: "Magical attack that deals Death damage to all enemies. Curses the target. Burns the target. Causes the target to bleed.",
        attackType: "magical",
        power: 180,
        damageTypes: [enums_1.DamageType.Death]
    },
    Transference: {
        name: "Transference",
        flavorText: "Magical attack that deals Death damage. Base power 60. Curses the target, healing the caster for 50% of the damage dealt by the curse.",
        attackType: "magical",
        power: 60,
        damageTypes: [enums_1.DamageType.Death]
    },
    Hoodoo: {
        name: "Hoodoo",
        flavorText: "Magical attack that deals Death damage. Base power 80. Damns the target.",
        attackType: "magical",
        power: 80,
        damageTypes: [enums_1.DamageType.Death]
    },
    Terror: {
        name: "Terror",
        flavorText: "Magical attack that deals Death damage. Base power 70. Stuns target.",
        attackType: "magical",
        power: 70,
        damageTypes: [enums_1.DamageType.Death]
    },
    Possess: {
        name: "Possess",
        flavorText: "Debuff that causes the target's soul to be possessed when it dies.",
        attackType: "debuff",
        power: 0,
        damageTypes: []
    },
    ConsumeSouls: {
        name: "Consume Souls",
        flavorText: "Consumes the souls capture by the caster to heal all allies.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    // Soul
    Abracadabra: {
        name: "Abracadabra",
        flavorText: "Performs a simple magic trick on an enemy.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Death]
    },
    // Assassin
    Cut: {
        name: "Cut",
        flavorText: "Physical attack that deals Physical damage. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    PoisonedBlades: {
        name: "Poisoned Blades",
        flavorText: "Physical attack that deals Physical and Nature damage. Base power 25. Poisons the target.",
        attackType: "physical",
        power: 25,
        damageTypes: [enums_1.DamageType.Physical, enums_1.DamageType.Nature]
    },
    MarkOfTheKunir: {
        name: "Mark of the Kunir",
        flavorText: "Self buff that increases the caster's Power and Poison Damage.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ContaminationOfRo: {
        name: "Contamination of Ro",
        flavorText: "Physical attack that deals Nature damage to all enemies. Base power 40. Poisons targets.",
        attackType: "physical",
        power: 40,
        damageTypes: [enums_1.DamageType.Nature]
    },
    IntoTheShadows: {
        name: "Into the Shadows",
        flavorText: "Self buff that removes negative effects and increases the caster's Toughness.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Strangle: {
        name: "Strangle",
        flavorText: "Physical attack that deals Physical damage. Base power 70. Stuns the target.",
        attackType: "physical",
        power: 70,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Mince: {
        name: "Mince",
        flavorText: "Physical attack that deals Physical damage to an enemy 3 to 6 times. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Bombardment: {
        name: "Bombardment",
        flavorText: "Physical attack that deals Physical and Fire damage to all enemies. Base power 60. Burns targets.",
        attackType: "physical",
        power: 60,
        damageTypes: [enums_1.DamageType.Physical, enums_1.DamageType.Fire]
    },
    Lacerate: {
        name: "Lacerate",
        flavorText: "Physical attack that deals Physical damage to an enemy. Base power 80. Causes the target to bleed.",
        attackType: "physical",
        power: 80,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Bandage: {
        name: "Bandage",
        flavorText: "Heals the caster for 25% of their max health. Caster regenerates health each turn.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    Assassinate: {
        name: "Assassinate",
        flavorText: "Physical attack that instantly kills non boss enemies. Deals Physical damage to bosses. Base power 180. Target becomes vulnerable.",
        attackType: "physical",
        power: 180,
        damageTypes: [enums_1.DamageType.Physical]
    },
    MasterOfPoisons: {
        name: "Master of Poisons",
        flavorText: "Passive buff that causes attacks to poison their target.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Avenger
    AvengingSlash: {
        name: "Avenging Slash",
        flavorText: "Physical attack that deals Holy damage. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Holy]
    },
    ShieldBash: {
        name: "Shield Bash",
        flavorText: "Physical attack that deals Holy damage. Base power 70. Stuns the target.",
        attackType: "physical",
        power: 70,
        damageTypes: [enums_1.DamageType.Holy]
    },
    Onslaught: {
        name: "Onslaught",
        flavorText: "Physical attack that deals Holy damage to all enemies. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Holy]
    },
    RosFortress: {
        name: "Ro's Fortress",
        flavorText: "Group buff that increases the Toughness and All Damage Immunity of allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    DoubleAttack: {
        name: "Double Attack",
        flavorText: "Passive Buff that causes the caster's abilities to activate an additional time.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Vengeance: {
        name: "Vengeance",
        flavorText: "Passive Buff that causes grants attacks a 50% chance to burn the target.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    RyversTouch: {
        name: "Ryver's Touch",
        flavorText: "Heals an ally and removes a random negative effect.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    TheBlockade: {
        name: "The Blockade",
        flavorText: "Group buff that increases the Will and All Damage Resistance of allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Revenge: {
        name: "Revenge",
        flavorText: "Passive buff that causes attacks to increase the damage the target takes.",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Holy]
    },
    TripleAttack: {
        name: "Triple Attack",
        flavorText: "Passive Buff that causes the caster's abilities to activate an additional time.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    RighteousFury: {
        name: "Righteous Fury",
        flavorText: "Self buff that increases Power and causes attacks to sometimes taunt their targets.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Apocalypse: {
        name: "Apocalypse",
        flavorText: "Physical attack that deals Holy damage. Base power 100.",
        attackType: "physical",
        power: 100,
        damageTypes: [enums_1.DamageType.Holy]
    },
    // The Tribunal
    Subjugate: {
        name: "Subjugate",
        flavorText: "TBD",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    RegenerativeLoop: {
        name: "Regenerative Loop",
        flavorText: "TBD",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    Erasure: {
        name: "Erasure",
        flavorText: "TBD",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    Collapse: {
        name: "Collapse",
        flavorText: "TBD",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    GravityFlux: {
        name: "Gravity Flux",
        flavorText: "TBD",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    PowerApex: {
        name: "Power Apex",
        flavorText: "TBD",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    TelestriasStarfall: {
        name: "Telestria's Starfall",
        flavorText: "TBD",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    AlissasLink: {
        name: "Alissa's Link",
        flavorText: "TBD",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    MagsParadox: {
        name: "Mag's Paradox",
        flavorText: "TBD",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    TelekineticForceWave: {
        name: "Telekinetic Force Wave",
        flavorText: "TBD",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    XyriasPardon: {
        name: "Xyria's Pardon",
        flavorText: "TBD",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    // Tempest
    FrostAndFireBolt: {
        name: "Frost and Fire Bolt",
        flavorText: "Magical attack that deals Frost and Fire damage. Base power 25.",
        attackType: "magical",
        power: 25,
        damageTypes: [enums_1.DamageType.Fire, enums_1.DamageType.Frost]
    },
    ElementalShield: {
        name: "Elemental Shield",
        flavorText: "Group buff that increases the will and damage resistance of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    LightningBolt: {
        name: "Lightning Bolt",
        flavorText: "Magical attack that deals Nature damage. Base power 50.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Nature]
    },
    MeteorStorm: {
        name: "Meteor Storm",
        flavorText: "Magical attack that deals Fire damage to all enemies. Base power 60.",
        attackType: "magical",
        power: 60,
        damageTypes: [enums_1.DamageType.Fire]
    },
    Stormstrike: {
        name: "Stormstrike",
        flavorText: "Magical attack that strikes an enemy 2 to 3 times dealing Nature and Physical damage. Base power 30.",
        attackType: "magical",
        power: 30,
        damageTypes: [enums_1.DamageType.Nature, enums_1.DamageType.Physical]
    },
    PermafrostVortex: {
        name: "Permafrost Vortex",
        flavorText: "Magical attack that deals Frost damage to all enemies. Base power 80. Slows targets.",
        attackType: "magical",
        power: 80,
        damageTypes: [enums_1.DamageType.Frost]
    },
    ArconBarrier: {
        name: "Arcon Barrier",
        flavorText: "Group buff that creates a protective barrier around each ally that absorbs damage.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Mirror: {
        name: "Mirror",
        flavorText: "Creates two identical copies of the caster that attack foes with Frost and Fire Bolts.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Inferno: {
        name: "Inferno",
        flavorText: "Magical attack that deals Fire damage. Base power 100. Burns the target.",
        attackType: "magical",
        power: 100,
        damageTypes: [enums_1.DamageType.Fire]
    },
    Disintegrate: {
        name: "Disintegrate",
        flavorText: "Magical attack that deals Death damage. Base power 220. Damage scales with remaining health.",
        attackType: "magical",
        power: 220,
        damageTypes: [enums_1.DamageType.Death]
    },
    KatjasHourglass: {
        name: "Katja's Hourglass",
        flavorText: "Group buff that rewinds time resetting the cooldowns of all allies and allowing the caster to take two more actions.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Ranger
    PiercingShot: {
        name: "Piercing Shot",
        flavorText: "Physical attack that deals Physical damage. Base power 45. Makes the target vulnerable.",
        attackType: "physical",
        power: 45,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Barrage: {
        name: "Barrage",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    ArcaneShot: {
        name: "Arcane Shot",
        flavorText: "Physical attack that deals Chaos damage 2 times to one enemy. Base power 35. Increases chaos damage taken by the target.",
        attackType: "physical",
        power: 35,
        damageTypes: [enums_1.DamageType.Chaos]
    },
    TheSupremeHunt: {
        name: "The Supreme Hunt",
        flavorText: "Self buff that increases the caster's power. Arcane shot will fire 4 arrows instead of 2.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    MarkOfThePredator: {
        name: "Mark of the Predator",
        flavorText: "Physical attack that deals Physical damage. Base power 100. Makes the target vulnerable.",
        attackType: "physical",
        power: 100,
        damageTypes: [enums_1.DamageType.Physical]
    },
    ResurrectPet: {
        name: "Resurrect Pet",
        flavorText: "Brings one of the caster's pets back to life.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    HealPet: {
        name: "Heal Pet",
        flavorText: "Heals the caster's pet.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    Redirection: {
        name: "Redirection",
        flavorText: "Debuff that forces all enemies to attack the caster's pet.",
        attackType: "debuff",
        power: 0,
        damageTypes: []
    },
    MurderedByCrows: {
        name: "Murdered by Crows",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 90. Makes target's vulnerable. Reduces targets' chance to hit.",
        attackType: "physical",
        power: 90,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Overkill: {
        name: "Overkill",
        flavorText: "Physical attack that deals Physical damage 2 to 5 times. Base power 50. Each arrow deals more damage than the previous.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    KillShot: {
        name: "Kill Shot",
        flavorText: "Physical attack that deals Physical and Chaos damage. Unblockable. Base power 75. Makes the target vulnerable.",
        attackType: "physical",
        power: 75,
        damageTypes: [enums_1.DamageType.Physical, enums_1.DamageType.Chaos]
    },
    CallOfTheWild: {
        name: "Call of the Wild",
        flavorText: "Passive buff that summons a pet to aid in battle.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    CautiousAim: {
        name: "Cautious Aim",
        flavorText: "Passive buff that increases the caster's Power.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    KillingMachine: {
        name: "Killing Machine",
        flavorText: "Passive buff that increases the base damage of overkill.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    MasterSharpshooter: {
        name: "Master Sharpshooter",
        flavorText: "Passive buff that causes attacks to cause the target to bleed.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Executioner
    Carve: {
        name: "Carve",
        flavorText: "Physical attack that deals Physical damage. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Impale: {
        name: "Impale",
        flavorText: "Physical attack that deals Physical damage. Base power 70. Causes the target to bleed.",
        attackType: "physical",
        power: 70,
        damageTypes: [enums_1.DamageType.Physical]
    },
    CommandingPresence: {
        name: "Commanding Presence",
        flavorText: "Passive Buff that increases the health of all allies while the caster's health is above 50%.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    PowerAmplification: {
        name: "Power Amplification",
        flavorText: "Group buff that increases the power and focus of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Pardon: {
        name: "Pardon",
        flavorText: "Removes all harmful effects from an ally.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    Indictment: {
        name: "Indictment",
        flavorText: "Physical attack that deals Physical damage. Base power 80. Makes the target vulnerable.",
        attackType: "physical",
        power: 80,
        damageTypes: [enums_1.DamageType.Physical]
    },
    OffWithTheirHead: {
        name: "Off With Their Head",
        flavorText: "Physical attack that deals Physical damage. Base power 100. Makes the target vulnerable.",
        attackType: "physical",
        power: 100,
        damageTypes: [enums_1.DamageType.Physical]
    },
    EternalPunishment: {
        name: "Eternal Punishment",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 50. Makes the targets vulnerable.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Berserk: {
        name: "Berserk",
        flavorText: "Group buff that increases the Power and Focus of allies. Allies are immune to stun and charm.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Execute: {
        name: "Execute",
        flavorText: "Physical attack that kills a non-boss Enemy. Deals Physical damage to bosses. Base power 180. Causes the target to bleed. Makes the target vulnerable.",
        attackType: "physical",
        power: 180,
        damageTypes: [enums_1.DamageType.Physical]
    },
    DramaticEndings: {
        name: "Dramatic Endings",
        flavorText: "Passive buff that increases the caster's health and power when an ally is killed.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Ranger Pet
    Bite: {
        name: "Bite",
        flavorText: "Physical attack that deals Physical damage. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Claw: {
        name: "Claw",
        flavorText: "Physical attack that deals Physical damage. Base power 55. Causes the target to bleed.",
        attackType: "physical",
        power: 55,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Roar: {
        name: "Roar",
        flavorText: "Group buff that increases the primary attributes of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Swipe: {
        name: "Swipe",
        flavorText: "Physical attack that deals Physical damage. Base power 60. Causes the target to bleed.",
        attackType: "physical",
        power: 60,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Pounce: {
        name: "Pounce",
        flavorText: "Physical attack that deals Physical damage. Base power 100. Target is stunned. Causes the target to bleed.",
        attackType: "physical",
        power: 100,
        damageTypes: [enums_1.DamageType.Physical]
    },
    // Gladiator
    GladiatorsStrike: {
        name: "Strike",
        flavorText: "Physical attack that deals Physical damage. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    TripleSlash: {
        name: "Triple Slash",
        flavorText: "Physical attack that deals Physical damage to all enemies 3 times. Base power 25.",
        attackType: "physical",
        power: 25,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Counter: {
        name: "Counter",
        flavorText: "Self buff that counters incoming attacks and damaging the attacker.",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Physical]
    },
    GladiatorsParry: {
        name: "Parry",
        flavorText: "Self buff that increases the casters toughness and damage resistance.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Burst: {
        name: "Burst",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 50. Makes targets vulnerable.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    InfinityStrike: {
        name: "Infinity Strike",
        flavorText: "Physical attack that deals Physical damage. Base power 100.",
        attackType: "physical",
        power: 100,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Disorder: {
        name: "Disorder",
        flavorText: "Physical attack that deals Physical damage to all enemies. Stuns targets.",
        attackType: "physical",
        power: 90,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Bloodthirsty: {
        name: "Bloodthirsty",
        flavorText: "Self buff that increases the caster's power and causes their attacks to leech life from their target.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    GladiatorsBandage: {
        name: "Bandage",
        flavorText: "Heals the caster for 25% of their max health. Caster regenerates health each turn.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    IndestructibleBattleCry: {
        name: "Indestructible Battle Cry",
        flavorText: "Group buff that increases the Vitality, Toughness and Will of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Fragment: {
        name: "Fragment",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 70. Makes the targets vulnerable.",
        attackType: "physical",
        power: 70,
        damageTypes: [enums_1.DamageType.Physical]
    },
    RegenerativeBattleCry: {
        name: "Regenerative Battle Cry",
        flavorText: "Group buff that increases the Health of all allies. Heals allies at the start of their turn.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Disembowel: {
        name: "Disembowel",
        flavorText: "Physical attack that deals Physical damage. Base power 150. Damage is increased if the target is vulnerable.",
        attackType: "physical",
        power: 150,
        damageTypes: [enums_1.DamageType.Physical]
    },
    // Monk
    StickEm: {
        name: "Stick 'em",
        flavorText: "Physical attack that deals Physical damage. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    KegToss: {
        name: "Keg Toss",
        flavorText: "Magical attack that deals Physical damage. Reduces the targets' chance to hit.",
        attackType: "magical",
        power: 40,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Whop: {
        name: "Whop",
        flavorText: "Physical attack that deals Physical damage. Base power 80. Makes the target vulnerable.",
        attackType: "physical",
        power: 80,
        damageTypes: [enums_1.DamageType.Physical]
    },
    GroupMeditation: {
        name: "Group Meditation",
        flavorText: "Heals all allies.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    Maul: {
        name: "Maul",
        flavorText: "Physical attack that deals Physical damage. Base power 70. Causes the target to bleed.",
        attackType: "physical",
        power: 70,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Flurry: {
        name: "Flurry",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 50. Increases the caster's Power for each enemy hit.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    ImpenetrableDefense: {
        name: "Impenetrable Defense",
        flavorText: "Group buff that increases the Toughness and Will of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    DrunkenClarity: {
        name: "Drunken Clarity",
        flavorText: "Group buff that increases the will and focus or power for all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    OleShakyStick: {
        name: "Ole Shaky Stick",
        flavorText: "Removes all negative effects from an ally.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    DeferDeath: {
        name: "Defer Death",
        flavorText: "Buff that prevents an ally from dying once.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    OldArtOfWar: {
        name: "Old Art of War",
        flavorText: "Magical attack that deals Death damage to an enemy. Base power 90. Targets is slowed. Makes the targets vulnerable.",
        attackType: "magical",
        power: 90,
        damageTypes: [enums_1.DamageType.Death]
    },
    DeathTouch: {
        name: "Death Touch",
        flavorText: "Magical attack that deals Death damage. Base power 180. Target is slowed. Target is cursed. Target's chance to hit is reduced. Makes the target vulnerable.",
        attackType: "magical",
        power: 180,
        damageTypes: [enums_1.DamageType.Death]
    },
    // Sunbreaker
    HammerSmash: {
        name: "Hammer Smash",
        flavorText: "Physical attack that deals Physical damage. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Dawnbreaker: {
        name: "Dawnbreaker",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    HammerThrow: {
        name: "Hammer Throw",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 60.",
        attackType: "physical",
        power: 60,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Radiance: {
        name: "Radiance",
        flavorText: "Passive buff that causes attacks to heal all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    DropTheHammer: {
        name: "Drop the Hammer",
        flavorText: "Physical attack that deals Holy damage. Base power 70. The hammer can then attack on its own.",
        attackType: "physical",
        power: 70,
        damageTypes: [enums_1.DamageType.Holy]
    },
    BrilliantShield: {
        name: "Brilliant Shield",
        flavorText: "Group buff that increases the will and damage resistance of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Guardian: {
        name: "Guardian",
        flavorText: "Group buff that increases the toughness and damage resistance of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    EarthShaker: {
        name: "Earth Shaker",
        flavorText: "Physical attack that deals nature damage to all enemies. Base power 70. May stun targets. May make targets vulnerable.",
        attackType: "physical",
        power: 70,
        damageTypes: [enums_1.DamageType.Nature]
    },
    ShockShield: {
        name: "Shock Shield",
        flavorText: "Passive buff that causes attacks to grant a damage shield to all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    StaggeringBlow: {
        name: "Staggering Blow",
        flavorText: "A physical attack that deals Physical damage. Base power 120. Makes the target vulnerable.",
        attackType: "physical",
        power: 120,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Starbreaker: {
        name: "Starbreaker",
        flavorText: "Self buff that increases damage dealt. Causes attacks to apply searing light and reduce the target's chance to hit.",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Holy]
    },
    // Thunder Caller
    Bolt: {
        name: "Bolt",
        flavorText: "Magical attack that deals Nature damage. Base power 50. Causes the target to convulse.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Nature]
    },
    ArcLightning: {
        name: "Arc Lightning",
        flavorText: "Magical attack that deals Nature damage to all enemies. Base power 50.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Nature]
    },
    ElectricSlide: {
        name: "Electric Slide",
        flavorText: "Magical attack that deals Nature damage. Base power 100. Deals more damage when the enemy has more health remaining. May cause target to convulse.",
        attackType: "magical",
        power: 100,
        damageTypes: [enums_1.DamageType.Nature]
    },
    Thunderstorm: {
        name: "Thunderstorm",
        flavorText: "Magical attack that deals Nature and Sonic damage to all enemies. Base power 50.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Nature, enums_1.DamageType.Sonic]
    },
    Downburst: {
        name: "Downburst",
        flavorText: "Magical attack that deals Nature damage. Slows the target. Base power 80.",
        attackType: "magical",
        power: 80,
        damageTypes: [enums_1.DamageType.Nature]
    },
    Hail: {
        name: "Hail",
        flavorText: "Magical attack that deals Frost damage to all enemies. Base power 60.",
        attackType: "magical",
        power: 60,
        damageTypes: [enums_1.DamageType.Frost]
    },
    Superbolt: {
        name: "Superbolt",
        flavorText: "Magical attack that deals Nature damage. Base power 70. Causes the target to convulse.",
        attackType: "magical",
        power: 70,
        damageTypes: [enums_1.DamageType.Nature]
    },
    Halo: {
        name: "Halo",
        flavorText: "Self buff that increases the caster's haste. The casters attacks slow enemies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Wrath: {
        name: "Wrath",
        flavorText: "Self buff that increases the caster's focus. Attacks make the target weak.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    LightningBond: {
        name: "Lightning Bond",
        flavorText: "Group buff that creates a bond between an ally Tempest and the caster, Granting both a 100% chance to critically strike.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ThunderCallersStrike: {
        name: "Strike",
        flavorText: "A magical attack that deals Sonic damage. Base power 150. Deals extra damage to convulsed targets. Causes the target to convulse.",
        attackType: "magical",
        power: 150,
        damageTypes: [enums_1.DamageType.Sonic]
    },
    // Druid
    BurstOfFire: {
        name: "Burst of Fire",
        flavorText: "Magical attack that deals Fire damage. Base power 45. Burns the target.",
        attackType: "magical",
        power: 45,
        damageTypes: [enums_1.DamageType.Fire]
    },
    Tangle: {
        name: "Tangle",
        flavorText: "Magical attack that deals Nature damage. Base power 70. Slows the target.",
        attackType: "magical",
        power: 70,
        damageTypes: [enums_1.DamageType.Nature]
    },
    HealingWater: {
        name: "Healing Water",
        flavorText: "Heals an ally. Target regenerates health each turn.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    Tornado: {
        name: "Tornado",
        flavorText: "Magical attack that deals Nature damage to all enemies. Base power 50.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Nature]
    },
    BriarBulwark: {
        name: "Briar Bulwark",
        flavorText: "Group buff that covers allies in protective thorns that damage attackers.",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Nature]
    },
    StingingSwarm: {
        name: "Stinging Swarm",
        flavorText: "Debuff that reduces an enemy's Will, Toughness and Nature Damage Immunity.",
        attackType: "debuff",
        power: 0,
        damageTypes: [enums_1.DamageType.Nature]
    },
    IceBlast: {
        name: "Ice Blast",
        flavorText: "Magical attack that deals Frost damage to all enemies. Base power 70. Targets are chilled and Frosty.",
        attackType: "magical",
        power: 70,
        damageTypes: [enums_1.DamageType.Frost]
    },
    DismissSummoned: {
        name: "Dismiss Summoned",
        flavorText: "Debuff that removes a summoned enemy of equal or lower level.",
        attackType: "magical",
        power: 0,
        damageTypes: []
    },
    NaturesRegeneration: {
        name: "Nature's Regeneration",
        flavorText: "Heals all allies. Targets regenerate health each turn.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    Cleansing: {
        name: "Cleansing",
        flavorText: "Removes all harmful effects from an ally.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    ForestsRejuvenation: {
        name: "Forest's Rejuvenation",
        flavorText: "Heals an ally and increases their maximum health.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    SpiritOfTheTreant: {
        name: "Spirit of the Treant",
        flavorText: "Self buff that transforms the caster into a treant. Increases the caster's focus and will. Resets the cooldown of Nature's Regeneration and Forest's Rejuvination.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Moonfire: {
        name: "Moonfire",
        flavorText: "Magical attack that deals Nature damage. Base power 70.",
        attackType: "magical",
        power: 70,
        damageTypes: [enums_1.DamageType.Nature]
    },
    Wildfire: {
        name: "Wildfire",
        flavorText: "Magical attack that deals Fire damage to all enemies. Base power 140. Burns all targets and reduces their Toughness and Will.",
        attackType: "magical",
        power: 140,
        damageTypes: [enums_1.DamageType.Fire]
    },
    // Necromancer
    DrainLife: {
        name: "Drain Life",
        flavorText: "Magical attack that deals Death damage. Base power 40. Heals the caster.",
        attackType: "magical",
        power: 40,
        damageTypes: [enums_1.DamageType.Death]
    },
    SummonSkeleton: {
        name: "Summon Skeleton",
        flavorText: "Summons a skeleton to fight for the caster. The caster may only have one active summon.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Fear: {
        name: "Fear",
        flavorText: "Debuff that stuns the target.",
        attackType: "debuff",
        power: 0,
        damageTypes: []
    },
    PoisonCloud: {
        name: "Poison Cloud",
        flavorText: "Magical attack that deals Nature damage to all enemies. Base power 50. Poisons all targets.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Nature]
    },
    SummonLich: {
        name: "Summon Lich",
        flavorText: "Summons a lich to fight for the caster. The caster may only have one active summon.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    NullifyMagic: {
        name: "Nullify Magic",
        flavorText: "Removes all harmful effects from allies.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    FuneralPyre: {
        name: "Funeral Pyre",
        flavorText: "Magical attack that deals Fire damage to all enemies. Base power 70. Burns targets.",
        attackType: "magical",
        power: 70,
        damageTypes: [enums_1.DamageType.Fire]
    },
    SummonSpirit: {
        name: "Summon Spirit",
        flavorText: "Summons a spirit to fight for the caster. The caster may only have one active summon.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    SpectralShield: {
        name: "Spectral Shield",
        flavorText: "Group buff that increases the Will and damage resistance of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    BestowLife: {
        name: "Bestow Life",
        flavorText: "Drains life from the caster to heal an ally.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    EternalDarkness: {
        name: "Eternal Darkness",
        flavorText: "Magical attack that deals Death damage. Base power 100. Reduces target's chance to hit. Target is cursed.",
        attackType: "magical",
        power: 100,
        damageTypes: [enums_1.DamageType.Death]
    },
    SummonReaper: {
        name: "Summon Reaper",
        flavorText: "Summons a reaper to fight for the caster. The caster may only have one active summon.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    SeedOfDarkness: {
        name: "Seed of Darkness",
        flavorText: "Magical attack that deals Death damage. Base power 80. Implants a seed of death within an enemy. The seed explodes at a later turn or when the enemy is killed.",
        attackType: "magical",
        power: 80,
        damageTypes: [enums_1.DamageType.Death]
    },
    Ruination: {
        name: "Ruination",
        flavorText: "Debuff that causes the caster's single target spells to deal additional damage.",
        attackType: "magical",
        power: 100,
        damageTypes: []
    },
    // Archangel
    UnholyFire: {
        name: "Unholy Fire",
        flavorText: "Wraps an enemy in dark flames. Target is burned.",
        attackType: "magical",
        power: 40,
        damageTypes: [enums_1.DamageType.Fire, enums_1.DamageType.Death]
    },
    // Necromancer's Pet Abilities
    SkeletalSlice: {
        name: "Skeletal Slice",
        flavorText: "Physical attack that deals Physical damage. Base power 50.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    Taunt: {
        name: "Taunt",
        flavorText: "Debuff that forces the target to attack the caster.",
        attackType: "debuff",
        power: 0,
        damageTypes: []
    },
    TouchOfTheDead: {
        name: "Touch of the Dead",
        flavorText: "Magic attack that deals Death damage. Base power 75. Heals the caster's master.",
        attackType: "magical",
        power: 75,
        damageTypes: [enums_1.DamageType.Death]
    },
    Decay: {
        name: "Decay",
        flavorText: "Magical attack that deals Death damage. Base power 60. Makes the target vulnerable.",
        attackType: "magical",
        power: 60,
        damageTypes: [enums_1.DamageType.Death]
    },
    Reap: {
        name: "Reap",
        flavorText: "Magical attack that deals Physical and Nature damage to all enemies. Base power 80. Poisons targets.",
        attackType: "magical",
        power: 80,
        damageTypes: [enums_1.DamageType.Physical, enums_1.DamageType.Nature]
    },
    // Gambler
    CardToss: {
        name: "Card Toss",
        flavorText: "Magical attack that deals Chaos damage. Base power 40. Heals allies.",
        attackType: "magical",
        power: 40,
        damageTypes: [enums_1.DamageType.Chaos]
    },
    Theft: {
        name: "Theft",
        flavorText: "Magical attack that deals Chaos damage. Base power 55. Reduces the primary attributes of the target and increases the caster's primary attributes.",
        attackType: "magical",
        power: 55,
        damageTypes: [enums_1.DamageType.Chaos]
    },
    HotStreak: {
        name: "Hot Streak",
        flavorText: "Passive buff that causes each succesful attack to increase damage dealt. Misses reset the damage increase.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    SweatEm: {
        name: "Sweat 'Em",
        flavorText: "Magical attack that deals Chaos damage. Base power 50. May slow all allies. May slow all enemies.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Chaos]
    },
    Bouncer: {
        name: "Bouncer",
        flavorText: "Summons a bouncer to keep the riff raff out.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    HighStakes: {
        name: "High Stakes",
        flavorText: "Magical attack that deals Chaos damage. Base power 100. Heals the enemy if it survives. Otherwise heals all allies.",
        attackType: "magical",
        power: 100,
        damageTypes: [enums_1.DamageType.Chaos]
    },
    Rage: {
        name: "Rage",
        flavorText: "Magical attack that deals Chaos damage to all enemies or allies. Targets are stunned.",
        attackType: "magical",
        power: 120,
        damageTypes: [enums_1.DamageType.Chaos]
    },
    DirksGambit: {
        name: "Dirk's Gambit",
        flavorText: "Sacrfices an ally (most of the time) to permanently increase the damage, toughness and will of all allies. Cannot sacrifice the caster.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    LoanShark: {
        name: "Loan Shark",
        flavorText: "Buff that loans some of the caster's attributes to an ally. Small chance to not repay the loan.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    BetTheHouse: {
        name: "Bet the House",
        flavorText: "Buff that sometimes does nothing. Otherwise increases all allies' or enemies' primary attributes.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ArcaneGamble: {
        name: "Arcane Gamble",
        flavorText: "Magical attack that deals Chaos damage. Power is random.",
        attackType: "magical",
        power: 100,
        damageTypes: [enums_1.DamageType.Chaos]
    },
    // Gambler's Pet: Bouncer
    Backhand: {
        name: "Backhand",
        flavorText: "Physical attack that deals Physical damage. Base power 45.",
        attackType: "physical",
        power: 45,
        damageTypes: [enums_1.DamageType.Physical]
    },
    // Hammer
    ItsHammerTime: {
        name: "It's Hammer Time",
        flavorText: "Physical attack that deals Physical damage to all enemies. Base power 50. Heals allies.",
        attackType: "physical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical]
    },
    // Hamm
    IntimidationOfTheKing: {
        name: "Intimidation",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    WatchThemDie: {
        name: "Watch them Die",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Enrage: {
        name: "Enrage",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    TheKingsWardrobe: {
        name: "Gladiator's Wardrobe",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Smite: {
        name: "Shatter",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    SecondStrike: {
        name: "Second Strike",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    RiotBreaker: {
        name: "Riot Breaker",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Ravyn, The Damned
    BloodyAura: {
        name: "Bloody Aura",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    GrimdinesCurse: {
        name: "Grimdine's Curse",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ScreamOfXira: {
        name: "Scream of Xira",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    BloodSacrifice: {
        name: "Blood Sacrifice",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    RavynsSlash: {
        name: "Ravyn's Slash",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Xyria
    XyriasLink: {
        name: "Xyria",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ShroudOfImmortality: {
        name: "Shroud of Immortality",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    AuraOfTheConqueror: {
        name: "Aura of the Conqueror",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    CrushingBlow: {
        name: "Crushing Blow",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    XyriasRegenerativeLoop: {
        name: "Xyria's Regenerative Loop",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Eternity: {
        name: "Eternity",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    TheDeathDoctrine: {
        name: "The Death Doctrine",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Lady Nyx
    Firestorm: {
        name: "Firestorm",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    MoarWhelps: {
        name: "Moar Whelps",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Meltdown: {
        name: "Meltdown",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Pyroblast: {
        name: "Pyroblast",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    BurningDesire: {
        name: "Burning Desire",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    DragonsBreath: {
        name: "Dragon's Breath",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Dragon Whelp
    TailSwipe: {
        name: "Tail Swipe",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Caedecus of the Arcane
    BeNoMore: {
        name: "Be No More",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    CaedecusArcaneBarrage: {
        name: "Caedecus' Arcane Barrage",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    CaedecusArcaneBlast: {
        name: "Caedecus' Arcane Blast",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    CosmicSmash: {
        name: "Cosmic Smash",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    OutOfTime: {
        name: "Out of Time",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    GazeOfPetrification: {
        name: "Gaze of Petrification",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Shade
    ArcaneBlast: {
        name: "Arcane Blast",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Dock Worker
    Pummel: {
        name: "Pummel",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Circus Monkey
    ThrowBanana: {
        name: "Throw Banana",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Werewolf
    VengefulHowl: {
        name: "Vengeful Howl",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Bloodletting: {
        name: "Bloodletting",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Mountain Giant
    GiantsCrush: {
        name: "Giant's Crush",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Fire Elemental
    ElementalBlessingFire: {
        name: "Elemental Blessing: Fire",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Frost Elemental
    ElementalBlessingFrost: {
        name: "Elemental Blessing: Frost",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Earth Elemental
    ElementalBlessingEarth: {
        name: "Elemental Blessing: Earth",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Energized Elemental
    ElementalBlessingLightning: {
        name: "Elemental Blessing: Lightning",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Basilisk Snake
    DeadlyIncision: {
        name: "Deadly Incision",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Chicken
    Peck: {
        name: "Peck",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Anomaly
    EnergyField: {
        name: "Energy Field",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Armored Mammoth
    Gore: {
        name: "Gore",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Charm: {
        name: "Charm",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    AncientDecay: {
        name: "AncientDecay",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    EmperorsRegeneration: {
        name: "Emperor's Regeneration",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    EmperorsSlice: {
        name: "Emperor's Slice",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    EmperorsSwiftness: {
        name: "Emperor's Swiftness",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    EmperorsWeakness: {
        name: "Emperor's Weakness",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    AncientElvenSlice: {
        name: "Ancient Elven Slice",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Stun: {
        name: "Stun",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    DaVu: {
        name: "Da'Vu",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    OldOrcishWays: {
        name: "Old Orcish Ways",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    HitsLikeAMackTrk: {
        name: "Hits Like a Ma'ck Tr'k",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Plague: {
        name: "Plague",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    SoulHarvest: {
        name: "Soul Harvest",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    SwordPlunge: {
        name: "Sword Plunge",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    WintersChill: {
        name: "Winter's Chill",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Shout: {
        name: "Shout",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Bounce: {
        name: "Bounce",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ClownSlap: {
        name: "Clown Slap",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ChasedByBears: {
        name: "Chased by Bears",
        flavorText: "Why'd it have to be bears?",
        attackType: "physical",
        power: 0,
        damageTypes: []
    },
    TheLionInMe: {
        name: "The Lion In Me",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Charge: {
        name: "Charge",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    CrushedByAnElephant: {
        name: "Crushed By An Elephant",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    RighteousIndignation: {
        name: "Righteous Indignation",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    HolyWater: {
        name: "Holy Water",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Malice: {
        name: "Malice",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Reinforcements: {
        name: "Reinforcements",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    TheodoresSmite: {
        name: "Theodore's Smite",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Launch: {
        name: "Launch",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ReflectiveCurse: {
        name: "Reflective Curse",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Trample: {
        name: "Trample",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ConstrictingVolley: {
        name: "Constricting Volley",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ReflexShot: {
        name: "Reflex Shot",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    QuickSlice: {
        name: "Quick Slice",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ThrowMagneticBomb: {
        name: "Throw Magnetic Bomb",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Heat: {
        name: "Heat",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ThirtyPounder: {
        name: "Thirty Pounder",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    BurningBreath: {
        name: "Burning Breath",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ColossalSmash: {
        name: "Colossal Smash",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    MeteorFist: {
        name: "Meteor Fist",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ViciousClaws: {
        name: "Vicious Claws",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    WarWolfsSwipe: {
        name: "Swipe",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    DragonWhelp_FirePuff: {
        name: "Fire Puff",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    DragonWhelp_Swipe: {
        name: "Swipe",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Cyndine
    BloodBeam: {
        name: "Blood Beam",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Bloodlust: {
        name: "Bloodlust",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    BloodSignet: {
        name: "Blood Signet",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    BloodyClaws: {
        name: "Bloody Claws",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    CyndinesSoulHarvest: {
        name: "Soul Harvest",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    DampeningCurse: {
        name: "Dampening Curse",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    FieryEnding: {
        name: "Fiery Ending",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    HiveMother: {
        name: "Hive Mother",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Magician
    MysticBolt: {
        name: "Mystic Bolt",
        flavorText: "Deals Chaos damage and has a chance to cause the target to take more elemental damage.",
        attackType: "magical",
        power: 45,
        damageTypes: [enums_1.DamageType.Chaos]
    },
    RainOfScimitars: {
        name: "Rain of Scimitars",
        flavorText: "Deals Physical and Fire damage to all enemies. Chance to make the targets bleed.",
        attackType: "magical",
        power: 35,
        damageTypes: [enums_1.DamageType.Physical, enums_1.DamageType.Fire]
    },
    SummonersTrickery: {
        name: "Summoner's Trickery",
        flavorText: "Causes the target to take more elemental damage.",
        attackType: "debuff",
        power: 0,
        damageTypes: []
    },
    ConjureSonicCrystal: {
        name: "Conjure Sonic Crystal",
        flavorText: "Summons a Sonic Crystal.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ConjureFireCrystal: {
        name: "Conjure Fire Crystal",
        flavorText: "Summons a Fire Crystal.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ConjureNatureCrystal: {
        name: "Conjure Nature Crystal",
        flavorText: "Summons a Nature Crystal.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ConjureFrostCrystal: {
        name: "Conjure Frost Crystal",
        flavorText: "Summons a Frost Crystal.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Jolt: {
        name: "Jolt",
        flavorText: "Deals damage for each active Crystal.",
        attackType: "magical",
        power: 30,
        damageTypes: [enums_1.DamageType.Chaos, enums_1.DamageType.Fire, enums_1.DamageType.Sonic, enums_1.DamageType.Fire, enums_1.DamageType.Frost]
    },
    AbolishMagic: {
        name: "Abolish Magic",
        flavorText: "Removes debuffs from all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    Burnout: {
        name: "Burnout",
        flavorText: "Increases the haste of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ShadowArmor: {
        name: "Shadow Armor",
        flavorText: "Causes all Crystals to wither would be attackers and increase the damage they take.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Shockwave: {
        name: "Shockwave",
        flavorText: "Deals Nature damage and poisons all enemies.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Nature]
    },
    Twincast: {
        name: "Twincast",
        flavorText: "Passive: Gives the Magician one extra action per turn.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    EnigmaticCapacity: {
        name: "Enigmatic Capacity",
        flavorText: "Increases the Critical Strike Chance of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Aegis: {
        name: "Aegis",
        flavorText: "Grants a Damage Absorb shield to all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Mirage: {
        name: "Mirage",
        flavorText: "Passive: Has a chance to summon a Mirage whenever the Magician is attacked.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    PrimordialSymbiosis: {
        name: "Primordial Symbiosis",
        flavorText: "Deals dmage to all enemies and Burns, Poisons, Chills and Sonic Pulses them.",
        attackType: "magical",
        power: 90,
        damageTypes: [enums_1.DamageType.Fire, enums_1.DamageType.Frost, enums_1.DamageType.Nature, enums_1.DamageType.Sonic]
    },
    SummonGreaterElementalServant: {
        name: "Summon Greater Elemental Servant",
        flavorText: "Requires all crystals to be active. Summons a Greater Elemental Servant to fight for the caster.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Greater Elemental Servant
    ElementalBlast: {
        name: "Elemental Blast",
        flavorText: "Deals damage for each active crystal.",
        attackType: "magical",
        power: 120,
        damageTypes: [enums_1.DamageType.Fire, enums_1.DamageType.Frost, enums_1.DamageType.Nature, enums_1.DamageType.Sonic]
    },
    // Magician's Crystals (Passive)
    ElementalShockFire: {
        name: "Elemental Shock: Fire",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Fire]
    },
    ElementalShockFrost: {
        name: "Elemental Shock: Frost",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Frost]
    },
    ElementalShockNature: {
        name: "Elemental Shock: Nature",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Nature]
    },
    ElementalShockSonic: {
        name: "Elemental Shock: Sonic",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Sonic]
    },
    // Bard
    MagsMenacingMelody: {
        name: "Mag's Menacing Melody",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Sonic]
    },
    ALuckyLamentation: {
        name: "A Lucky Lamentation",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    NorthsElegy: {
        name: "North's Elegy",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    SongOfMidnight: {
        name: "Song of Midnight",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Sonic]
    },
    BigsBoastfulBellow: {
        name: "Big's Boastful Bellow",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    ShaunisShanty: {
        name: "Shauni's Shanty",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Sonic]
    },
    AlaresasAppallingSquall: {
        name: "Alaresa's Appalling Squall",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Sonic]
    },
    PrestigesPerfectPiece: {
        name: "Prestige's Perfect Piece",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    NjordsLullaby: {
        name: "Njord's Lullaby",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    HealingRhythm: {
        name: "Healing Rhythm",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    SonorasShield: {
        name: "Sonora's Shield",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    DirksDevastatingDitty: {
        name: "Dirk's Devastating Ditty",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Sonic]
    },
    NearsMissingNote: {
        name: "Near's Missing Note",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: [enums_1.DamageType.Sonic]
    },
    HishasHarmony: {
        name: "Hisha's Harmony",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    CantataOfTaluvias: {
        name: "Cantata of Taluvias",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    HymnOfHeimdall: {
        name: "Hymn of Heimdall",
        flavorText: "TBD",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // misc.
    ArcaneBarrage: {
        name: "Arcane Barrage",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    LikeABoss: {
        name: "Like a Boss",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Cerberus
    Cerberus_MeltArmor: {
        name: "Melt Armor",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    HellsFury: {
        name: "Hell's Fury",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    HellsRetribution: {
        name: "Hell's Retribution",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    // Buddy the Penguin
    StayFrosty: {
        name: "Stay Frosty",
        flavorText: "Magical attack that deals Frost damage. Slows affected targets.",
        attackType: "magical",
        power: 30,
        damageTypes: [enums_1.DamageType.Frost],
    },
    CruelWinter: {
        name: "Cruel Winter",
        flavorText: "Magical attack that deals Frost damage. Increases frost damage taken by the target.",
        attackType: "magical",
        power: 70,
        damageTypes: [enums_1.DamageType.Frost],
    },
    Frostshield: {
        name: "Frostshield",
        flavorText: "Reduces damage taken by all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    IceLance: {
        name: "Ice Lance",
        flavorText: "Magical attack that deals Frost damage. Causes the target to bleed.",
        attackType: "magical",
        power: 80,
        damageTypes: [enums_1.DamageType.Frost],
    },
    DigIn: {
        name: "Dig In",
        flavorText: "Makes all allies immune to charm and stun.",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    Frostward: {
        name: "Frostward",
        flavorText: "Reduces damage taken by all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    Frostfall: {
        name: "Frostfall",
        flavorText: "Magical attack that deals Frost damage. Reduces target's Power, Focus, Will and Toughness.",
        attackType: "magical",
        power: 90,
        damageTypes: [enums_1.DamageType.Frost],
    },
    PenguinPummel: {
        name: "Penguin Pummel",
        flavorText: "Pummels enemies with exploding penguins. Randomly buffs allies and debuffs enemies.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Physical],
    },
    WallOfFrost: {
        name: "Wall of Frost",
        flavorText: "Blasts foes with ice dealing Frost damage. Increases Frost and Death damage taken by enemies.",
        attackType: "magical",
        power: 160,
        damageTypes: [enums_1.DamageType.Frost],
    },
    IceSpikeShield: {
        name: "Ice Spike Shield",
        flavorText: "Applies a shield of ice to all allies that reflects damage and causes attackers to bleed.",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    WarmingPresence: {
        name: "Warming Presence",
        flavorText: "Increases primary attributes of all allies and grants a damage absorption shield.",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    BlessingOfFrost: {
        name: "Blessing of Frost",
        flavorText: "Wraps all allies in ice bubbles that slow attackers.",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    CallOfTheSnowman: {
        name: "Call of the Snowman",
        flavorText: "Summons a mystical snowman to aid the party.",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    IcicleStorm: {
        name: "Icicle Storm",
        flavorText: "Hurls icicles at random enemies. Each icicle causes a random ally to apply frostbite to attackers.",
        attackType: "magical",
        power: 50,
        damageTypes: [enums_1.DamageType.Frost, enums_1.DamageType.Death],
    },
    ElementalDischarge: {
        name: "Elemental Discharge",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    VoidZone: {
        name: "Void Zone",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    ElementalOverload: {
        name: "Elemental Overload",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    Stormfall: {
        name: "Stormfall",
        flavorText: "",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    HorsemansInferno: {
        name: "Horseman's Inferno",
        flavorText: "Magical attack that deals both Death and Fire damage. Applies an unwordly burn to the target.",
        attackType: "magical",
        power: 100,
        damageTypes: [
            enums_1.DamageType.Death, enums_1.DamageType.Fire
        ],
    },
    Boo: {
        name: "Boo",
        flavorText: "Boo! Magical attack that deals Death damage and has a chance to apply a stun from fear.",
        attackType: "magical",
        power: 40,
        damageTypes: [
            enums_1.DamageType.Death
        ],
    },
    UndeadResolve: {
        name: "Undead Resolve",
        flavorText: "A supernatural resolve that buff's this undead creature. Damage weakens this effect.",
        attackType: "buff",
        power: 0,
        damageTypes: [],
    },
    COW_DragonWhelp_Flare: {
        name: "Flare",
        flavorText: "Magical attack that deals Fire damage and applies Darkness to the target.",
        attackType: "magical",
        power: 45,
        damageTypes: [
            enums_1.DamageType.Fire
        ]
    },
    COW_DragonWhelp_Cauterize: {
        name: "Cauterize",
        flavorText: "Heals an ally.",
        attackType: "healing",
        power: 0,
        damageTypes: []
    },
    COW_DragonWhelp_Scorch: {
        name: "Scorch",
        flavorText: "Deals Fire damage and increases Fire damage taken by the target.",
        attackType: "magical",
        power: 80,
        damageTypes: []
    },
    COW_DragonWhelp_Kindle: {
        name: "Kindle",
        flavorText: "Increases the Critical Strike Chance and Haste of all allies.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    },
    COW_DragonWhelp_FireBreath: {
        name: "Fire Breath",
        flavorText: "Deals Fire damage to all enemies. Causes enemies to burn.",
        attackType: "magical",
        power: 70,
        damageTypes: []
    },
    ColdlightVortex: {
        name: "Coldlight Vortex",
        flavorText: "",
        attackType: "magical",
        power: 80,
        damageTypes: [
            enums_1.DamageType.Frost
        ]
    },
    Coldbolt: {
        name: "Coldbolt",
        flavorText: "",
        attackType: "magical",
        power: 80,
        damageTypes: [
            enums_1.DamageType.Frost
        ]
    },
    ChillyEmpowerment: {
        name: "Chilly Empowerment",
        flavorText: "Passive buff that causes 1 harmful DoT effect to be applied to the attacker on attacks.",
        attackType: "buff",
        power: 0,
        damageTypes: []
    }
};
